export const hamburgerButton = document.querySelector('#js-hamburger-button');
export const overlay = document.querySelector('#js-overlay');
export const header = document.querySelector('#header');
export const logo = document.querySelector('#js-logo');
export const menuPrimary = document.querySelector('#js-menu-primary');
export const menuParentItems = menuPrimary.querySelectorAll('[aria-expanded]');

export const languageCode = document.documentElement.lang;
export const STORAGE_KEY = 'user-color-scheme';
export const COLOR_MODE_KEY = '--color-mode';
export const modeToggleButton = document.querySelector('.js-mode-toggle');
export const modeToggleText = document.querySelector('.js-mode-toggle-text');
export const modeStatusElement = document.querySelector('.js-mode-status');
export const viewport = document.documentElement;
export const sidebar = document.querySelector('#js-sidebar');
const MQ_MENU = '(min-width: 768px)';
export const mqMenu = window.matchMedia(MQ_MENU);
export const notification = document.querySelector('.js-notification');
export const dismissNotificationButton = document.querySelector(
  '#js-dismiss-notification'
);
export const cards = document.querySelectorAll('.js-card');
export const footerMenu = document.getElementById('js-menu-footer');
export const themeButtons = document.querySelectorAll(
  '#js-theme-toggle .js-theme-option'
);
export const calendarButtons = document.querySelectorAll(
  '#js-calendar-options .js-calendar-toggle'
);
